import { BOAT_RACE_IMAGES, BOAT_RACE_REFERENCE_LINKS_EN } from './boatRacePostUtils';

const GALLERY_IMAGES = {
  heats: BOAT_RACE_IMAGES.heats,
  alleppey: BOAT_RACE_IMAGES.alleppey,
  aranmula: BOAT_RACE_IMAGES.aranmula,
  boats: BOAT_RACE_IMAGES.boats,
};

/** 72nd Nehru Trophy Boat Race 2026 — chundan boats, clubs, captains (English) */
export const NEHRU_TROPHY_ENGLISH_POST = {
  id: 'featured-nehru-trophy-2026-english',
  slug: 'nehru-trophy-2026-chundan-snake-boats-captains',
  title: '72nd Nehru Trophy Boat Race 2026: 22 Chundan Boats, Clubs & Captains',
  excerpt:
    '22 August at Punnamada: all 22 snake boats and clubs, captain / haripp captain details, photo gallery, and Malayalam TV highlights — full English guide to NTBR 2026.',
  publishedAt: '2026-08-13T14:00:00.000Z',
  coverImageUrl: BOAT_RACE_IMAGES.hero,
  authorName: 'Daily Sports Life',
  clubName: 'Kerala Sports Desk',
  blogCategory: 'boat-races',
  locale: 'en',
  boatRaceTopic: 'chundan-2026',
  alternateSlug: 'nehru-trophy-2026-chundan-vallam-malayalam',
  featured: true,
  component: 'WellnessGuideBlogArticle',
  theme: 'diet',
  relatedPostsTitle: 'Related boat race articles',
  relatedPosts: [
    {
      slug: 'nehru-trophy-2026-chundan-vallam-malayalam',
      title: '72-ാം നെഹ്‌റു ട്രോഫി 2026: ചുണ്ടൻ വള്ളങ്ങൾ, ക്ലബുകൾ, കാപ്റ്റൻമാർ (മലയാളം)',
      blurb: 'Malayalam edition — same line-up with full local detail.',
    },
    {
      slug: 'thalavady-chundan-history-ntbr-cbl-2026',
      title: 'Thalavady Chundan: History, Victories & NTBR / CBL 2026',
      blurb: 'Aaram Thamburan — Neerattupuram winner rowing into NTBR 2026.',
    },
    {
      slug: 'kerala-boat-race-nehru-trophy-ntbr-history',
      title: 'Kerala Boat Race Guide: NTBR 2026 & Nehru Trophy History',
      blurb: 'History, visitor tips, and vallamkali background.',
    },
  ],
  referenceLinks: [
    ...BOAT_RACE_REFERENCE_LINKS_EN,
    {
      label: 'Track & heat schedule',
      url: 'https://nehrutrophy.nic.in/pages-en-IN/track.php',
    },
    {
      label: 'The Hindu — 2026 preparations',
      url: 'https://www.thehindu.com/news/national/kerala/boat-clubs-in-kerala-shift-into-high-gear-as-kuttanad-readies-for-prestigious-nehru-trophy-boat-race/article71271895.ece',
    },
  ],
  sections: [
    {
      type: 'stats',
      ariaLabel: 'NTBR 2026 at a glance',
      items: [
        { value: '22 Aug 2026', label: '72nd Nehru Trophy' },
        { value: '22', label: 'Chundan snake boats' },
        { value: '71', label: 'Total boats entered' },
        { value: '1.4 km', label: 'Main race course' },
      ],
    },
    {
      type: 'panel',
      title: 'Punnamada’s excitement returns',
      paragraphs: [
        'When Kerala’s monsoon arrives, quiet backwaters become race tracks. **Vallamkali** — boat play — is the heartbeat of **Kuttanad**. The biggest stage is the **Nehru Trophy Boat Race (NTBR)**.',
        'The **72nd Nehru Trophy Boat Race 2026** is set for **Saturday, 22 August 2026** on **Punnamada Lake, Alappuzha**. This year **71 boats** are registered across classes. The headline **chundan** (snake boat) division alone has **22 entries** — one more than last season.',
        'A **chundan** with 100–150 oarsmen is a village’s pride. Winning villages celebrate for days. Malayalees worldwide wait for this one Saturday on TV and streaming.',
      ],
      chips: ['Vallamkali', 'Chundan', 'Punnamada', 'Kuttanad', 'Onam'],
    },
    {
      type: 'panel',
      title: 'What is a chundan vallam?',
      paragraphs: [
        'The **chundan vallam** is Kerala’s traditional war canoe. Roughly 100–138 feet long with a raised cobra-hood prow, built mainly from **anjili** wood. Crews of **100–150** include oarsmen, helmsmen (**amarakkar**), singers, and rhythm keepers.',
        'In **1952**, when Jawaharlal Nehru visited Alappuzha, **Nadubhagam Chundan** won an impromptu race. Nehru boarded the winning boat — and later donated the silver trophy that became the **Nehru Trophy**.',
      ],
    },
    {
      type: 'imageGallery',
      title: 'Punnamada in pictures',
      intro: 'Real Nehru Trophy race scenes from Wikimedia Commons (CC BY-SA).',
      images: [
        {
          url: GALLERY_IMAGES.heats,
          alt: 'Nehru Trophy 2024 — chundan heat',
          caption: 'Nehru Trophy Boat Race 2024, Punnamada — Varghesepunnamada / Wikimedia.',
        },
        {
          url: GALLERY_IMAGES.alleppey,
          alt: 'Nehru Trophy, Alleppey',
          caption: 'Nehru Trophy vallamkali, Alleppey — Wikimedia Commons.',
        },
        {
          url: GALLERY_IMAGES.aranmula,
          alt: 'Kerala boat race — snake boats',
          caption: 'Chundan vallams, Kerala — Anoopkn / Wikimedia.',
        },
        {
          url: GALLERY_IMAGES.boats,
          alt: 'Boats on the water',
          caption: 'The rhythm of the oars — Kuttanad’s heartbeat.',
        },
      ],
    },
    {
      type: 'panel',
      title: '2026 highlight: first woman chundan captain',
      paragraphs: [
        '**Nadubhagam Chundan** makes history this year. **Anu Albert Pulikkattil** captains the PBC Punnamada team — the **first woman captain** in a Nehru Trophy chundan final. (*The Hindu*, 2026)',
        'Nadubhagam is the legendary boat that drew Nehru in 1952. In 2026 it opens a new chapter for women in Kuttanad’s traditional sport.',
      ],
      chips: ['Nadubhagam', 'Anu Albert Pulikkattil', 'History', 'PBC Punnamada'],
    },
    {
      type: 'table',
      title: '22 chundan boats, clubs & captains',
      intro:
        '2026 registration plus available captain details (2024–2026 official/media reports). Confirm final lists at [nehrutrophy.nic.in](https://nehrutrophy.nic.in/) before race day. «—» = not yet publicly announced.',
      headers: ['#', 'Chundan boat', 'Boat club', 'Captain / Haripp captain'],
      rows: [
        ['1', 'Thalavadi Chundan', 'Kainakari Village Boat Club', 'Padmakumar Puthenparambil / Rahul Prakash'],
        ['2', 'Veeyapuram Chundan', 'UBC Kainakari', 'Baiju Kuttanad (2025 winning team)'],
        ['3', 'Aroma Chundan 1', 'Aroma Boat Club', '—'],
        ['4', 'Melpadam Chundan', 'Pallathuruthy Boat Club', '—'],
        ['5', 'Cheruthana Chundan', 'Nattakam Boat Club', 'Madhu Kuthappan / K. Shaji'],
        ['6', 'Punyalan Niranam Chundan', 'Kumarakom Town Boat Club', '—'],
        ['7', 'Nadubhagam Chundan', 'PBC Punnamada / NCFS', '**Anu Albert Pulikkattil** (2026)'],
        ['8', 'Karuvatta Chundan', 'GLC Boat Club, Cheruthana', '—'],
        ['9', 'Vellamkulangara Chundan', 'SH Boat Club', '—'],
        ['10', 'Jawahar Thayankari Chundan', 'Nattakam Fans Boat Club', 'Aswanth V. Perumbidakkalam / Benny Baby'],
        ['11', 'St. Pius X Chundan', 'St. Pius X Boat Club', 'Renny Philippose Puthenparambil'],
        ['12', 'Niranam Chundan', 'Niranam Boat Club', 'K.G. Abraham / Binu Shaji'],
        ['13', 'Ayaparambu Valiya Divanji Chundan', 'Valiya Divanji Boat Club', 'Sunny Edimannickal / Baijappan'],
        ['14', 'Anari Chundan', 'Anari Boat Club', '—'],
        ['15', 'Champakulam Chundan', 'Champakulam Boat Club', 'Santhosh T. Kuruvilla / Harilal K.V.'],
        ['16', 'Karichal Chundan', 'Thekkekkara Boat Club', 'Alan Moonnudaykkal'],
        ['17', 'Ayaparambu Pandi Chundan', 'IBRA, Kochi', '—'],
        ['18', 'Karuvatta Sree Vinayakan Chundan', 'KTBC Fans Club', '—'],
        ['19', 'Arpookkara Chundan', 'Kumarakom Emmanuel Boat Club', '—'],
        ['20', 'Alappad Chundan', 'St. Johns Boat Club', '—'],
        ['21', 'Payippadan 2 Chundan', 'Pallathuruthy Boat Club', 'Mahesh Krishnan Nair / Sajan A.J.'],
        ['22', 'Parthhan Chundan', 'Junior Kainakari Boat Club', '—'],
      ],
    },
    {
      type: 'table',
      title: '22 chundan boats & clubs (quick reference)',
      intro: 'Club names only — for a fast scan.',
      headers: ['#', 'Chundan boat', 'Boat club'],
      rows: [
        ['1', 'Thalavadi Chundan', 'Kainakari Village Boat Club'],
        ['2', 'Veeyapuram Chundan', 'UBC Kainakari'],
        ['3', 'Aroma Chundan 1', 'Aroma Boat Club'],
        ['4', 'Melpadam Chundan', 'Pallathuruthy Boat Club'],
        ['5', 'Cheruthana Chundan', 'Nattakam Boat Club'],
        ['6', 'Punyalan Niranam Chundan', 'Kumarakom Town Boat Club'],
        ['7', 'Nadubhagam Chundan', 'PBC Punnamada / Nadubhagam Fans Club'],
        ['8', 'Karuvatta Chundan', 'GLC Boat Club, Cheruthana'],
        ['9', 'Vellamkulangara Chundan', 'SH Boat Club'],
        ['10', 'Jawahar Thayankari Chundan', 'Nattakam Fans Boat Club'],
        ['11', 'St. Pius X Chundan', 'St. Pius X Boat Club'],
        ['12', 'Niranam Chundan', 'Niranam Boat Club'],
        ['13', 'Ayaparambu Valiya Divanji Chundan', 'Valiya Divanji Boat Club'],
        ['14', 'Anari Chundan', 'Anari Boat Club'],
        ['15', 'Champakulam Chundan', 'Champakulam Boat Club'],
        ['16', 'Karichal Chundan', 'Thekkekkara Boat Club'],
        ['17', 'Ayaparambu Pandi Chundan', 'IBRA, Kochi'],
        ['18', 'Karuvatta Sree Vinayakan Chundan', 'KTBC Fans Club'],
        ['19', 'Arpookkara Chundan', 'Kumarakom Emmanuel Boat Club'],
        ['20', 'Alappad Chundan', 'St. Johns Boat Club'],
        ['21', 'Payippadan 2 Chundan', 'Pallathuruthy Boat Club'],
        ['22', 'Parthhan Chundan', 'Junior Kainakari Boat Club'],
      ],
    },
    {
      type: 'videoEmbed',
      title: 'Malayalam video — Nehru Trophy highlight',
      intro:
        'Asianet News highlight from a recent season. On 22 August 2026, live coverage is expected on Asianet, Manorama, and DD Malayalam.',
      embeds: [
        {
          youtubeId: '0-rJfoKw9K0',
          title: 'Nehru Trophy Boat Race 2023 — Asianet News Malayalam',
          caption:
            '**Asianet News:** final moments of the chundan race — rhythm and roar of a hundred oars.',
        },
      ],
    },
    {
      type: 'videoList',
      title: 'Live & highlights — YouTube channels',
      intro: 'On race day, search «Nehru Trophy boat race» on these channels.',
      videos: [
        {
          title: 'Asianet News Live',
          channel: 'Asianet News',
          description: 'Major Kerala news channel — regular NTBR live coverage.',
          url: 'https://www.youtube.com/@asianetnews',
        },
        {
          title: 'Manorama News',
          channel: 'Manorama News',
          description: 'Final highlights and live streams from recent NTBR editions.',
          url: 'https://www.youtube.com/@manoramanews',
        },
        {
          title: 'MediaOne Live',
          channel: 'MediaOne',
          description: 'Malayalam news coverage through vallamkali season.',
          url: 'https://www.youtube.com/@MediaOneTVLive',
        },
        {
          title: 'DD Malayalam',
          channel: 'Doordarshan Malayalam',
          description: 'Public broadcaster NTBR telecast (varies by year).',
          url: 'https://www.youtube.com/@DoordarshanMalayalam',
        },
      ],
    },
    {
      type: 'panel',
      title: '2025 final — context for 2026',
      paragraphs: [
        'The **71st Nehru Trophy (2025)** was won by **Veeyapuram Chundan** (Kainakari Village Boat Club) in **4:21.084**. Photo finish: **Nadubhagam** second, **Melpadam** third, **Niranam** fourth.',
        'This year’s line-up mixes established names — **Veeyapuram**, **Nadubhagam**, **Karichal**, **Champakulam**, **Niranam** — with newer faces like **Aroma** and **Parthhan**.',
      ],
      list: [
        '**Nadubhagam Chundan** — the 1952 legend; captained by Anu Albert in 2026.',
        '**Karichal Chundan** — one of Kuttanad’s most popular boats; 2024 winner.',
        '**Champakulam Chundan** — Champakulam Moolam vallamkali heritage.',
        '**Parthhan Chundan** — Junior Kainakari Club’s fresh campaign.',
      ],
    },
    {
      type: 'table',
      title: 'Other boat classes (2026)',
      intro: 'Beyond the chundan final: churulan, iruttukuthy, veppu, tekkanodi, and more.',
      headers: ['Class', 'Boats entered', 'Notes'],
      rows: [
        ['Churulan', '2', 'Smaller boat; local competition'],
        ['Iruttukuthy A', '3', 'Iruttukuthy division — A grade'],
        ['Iruttukuthy B', '16', 'One of the largest sub-divisions'],
        ['Iruttukuthy C', '14', 'Heats and losers rounds'],
        ['Veppu A', '5', 'Traditional veppu boat'],
        ['Veppu B', '4', 'Veppu B class'],
        ['Tekkanodi Thara', '1', 'Tekkanodi class'],
        ['Tekkanodi Kettu', '4', 'Tekkanodi kettu class'],
      ],
    },
    {
      type: 'panel',
      title: 'Race day — what to expect',
      orderedList: [
        '**Date:** Saturday, 22 August 2026',
        '**Venue:** Punnamada Lake, Alappuzha',
        '**Distance:** ~1.4 km chundan final course',
        '**Prize:** Government-announced winner’s purse (up to ₹25 lakh — confirm for 2026)',
        '**Tickets:** Online at [nehrutrophy.nic.in](https://nehrutrophy.nic.in/pages-en-IN/online_ticket.php)',
        '**Crowds:** 200,000+ spectators — arrive early',
      ],
      paragraphs: [
        'Morning processions with decorated boats and **chenda** drums; afternoon heats. Evening **chundan final** — the sound of synchronized oars, **vanchippattu**, and drums — NTBR’s timeless image.',
        'The **Champions Boat League (CBL)** season also kicks off in 2026; NTBR is the opening marquee.',
      ],
    },
    {
      type: 'panel',
      title: 'Tips for spectators',
      list: [
        'Book Alappuzha hotels and houseboats early — race weekend fills fast.',
        'Buy tickets only through official NTBR channels.',
        'Bring sunscreen, rain gear, and water.',
        'Respect the boats and banks — living culture, not just tourism.',
        'Watching from abroad: check Malayalam TV/streaming schedules and time zones.',
      ],
      callout: {
        text: 'Book official tickets →',
        url: 'https://nehrutrophy.nic.in/pages-en-IN/online_ticket.php',
      },
    },
    {
      type: 'panel',
      title: 'In short',
      paragraphs: [
        'The **72nd Nehru Trophy Boat Race** is Kerala’s greatest water festival. In 2026, **22 chundan boats** and **71 boats overall** bring Kuttanad’s village clubs to Punnamada.',
        'Whether you are in Alappuzha, America, or Europe — on this Saturday the lake’s rhythm reaches every heart. **Good strokes, good rhythm, good racing!**',
      ],
      chips: ['Nehru Trophy', 'Chundan', 'Vallamkali', 'Alappuzha', '2026'],
    },
  ],
};
